var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoofroxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42.667,
    height: 42.667,
    viewBox: "0 0 42.667 42.667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h32v-32h-32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "#008b6c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.622 22.829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v1.085h4.105v1.499h-5.78v-2.584z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.622 19.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v1.609h3.613v1.5h-5.288v-4.609h5.835v1.5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.448 21.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.621 4.102h-1.916l-1.585-2.621z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.822 23.127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.359 2.286h-1.97l2.945-4.505v-3.158h1.685v3.191z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.6424 22.754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v2.659h-1.686v-4.475z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.6677,22.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.12 3.251h-2.036l-4.795-5.166v-2.497h1.686v2.343l.887.92 2.375-3.263h2.025z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m4.957 6.726h1.686v1.829h-1.686z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath377)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.3136 11.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-.657-.493-1.16-1.336-1.16h-1.335v2.342h1.303c.842 0 1.368-.405 1.368-1.16zm-1.226 2.704h-3.131v-5.364h2.967c1.718 0 3.098.919 3.098 2.693v.022c0 1.565-1.106 2.649-2.934 2.649",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.153 10.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.146-.04-.309-.063-.49-.063h-1.708v2.201h1.675c.821 0 1.325-.372 1.325-1.095v-.022c0-.34-.132-.621-.375-.813l.872-1.274c.734.416 1.21 1.131 1.21 2.175v.022c0 .722-.23 1.324-.657 1.751-.503.504-1.258.777-2.233.777h-3.503v-7.663h1.686v2.453h1.325l1.642-2.453h1.97z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.549 10.737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-.098 2.058-1.749 3.674-3.766 3.77l.019-1.794c1.066-.101 1.908-.966 1.959-2.061.028-.58-.172-1.136-.562-1.565-.392-.43-.926-.681-1.506-.708-.027-.002-.054-.002-.081-.002-1.174-.013-2.137.896-2.192 2.07-.028.58.172 1.136.563 1.565.355.391.83.632 1.35.693l-.02 1.796c-2.142-.149-3.783-1.982-3.681-4.139.102-2.137 1.877-3.798 3.999-3.775.049 0 .097.002.147.004 2.186.103 3.874 1.96 3.771 4.146",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofroxCheck);
export default __webpack_public_path__ + "static/media/RoofroxCheck.9d872f0b57b623b18c7b4a369424e288.svg";
export { ForwardRef as ReactComponent };